<template>
  <v-dialog v-model="dialog" persistent eager max-width="600">
    <v-card-title class="navy darken-1 white--text">
      <div v-if="isAdminSet">
        <v-icon class="white--text" left>edit</v-icon>
        Modifica amministratore asta
      </div>
      <div v-else>Imposta amministratore asta</div>
      <v-spacer></v-spacer>
      <v-btn depressed class="white--text" light icon @click="dismiss">
        <v-icon>close</v-icon>
      </v-btn>
    </v-card-title>
    <v-sheet class="white" >
      <div class="pa-4">

        <v-alert
          dense
        text
        color="error"
        icon="warning"
         v-if="!isAdminSet" class="mb-4 font-weight-bold"
        >Prima di iniziare si deve impostare un amministratore d'asta.</v-alert>

        <v-alert
          dense
        text

        color="cyan darken-2"

        >

          <div class="py-4" v-if="asta_squadre_array.length > 0">
        <v-select
          :key="adminSelectKey"
          v-model="selectedAdminUid"
          :items="adminSquadreOptions"
          item-text="name"
          item-value="id"
          item-disabled="disabled"
          :menu-props="{ offsetY: true, contentClass: 'admin-squadre-menu' }"
          outlined
          dense
          hide-details
          class="admin-select-cyan"
          placeholder="Seleziona amministratore d'asta"
          @change="change"
        >
          <template v-slot:selection="{ item }">
            <div class="admin-squadra-option">
              <v-avatar size="32" class="mr-3">
                <img :src="item.pic" />
              </v-avatar>
              <span class="stato mr-2" :class="item.presenceClass"></span>
              <span class="admin-squadra-name">{{ item.name }}</span>
            </div>
          </template>
          <template v-slot:item="{ item }">
            <v-list-item-avatar>
              <img :src="item.pic" />
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>
                <span class="stato mr-2" :class="item.presenceClass"></span>
                <span class="admin-squadra-name">{{ item.name }}</span>
              </v-list-item-title>
            </v-list-item-content>
          </template>
        </v-select>
      </div>
      <div v-else class="text-center pa-4">
        <div>
          Nessuna squadra a cui poter assegnare il ruolo di Amministratore
          d'asta.
        </div>
        <v-btn rounded small outlined @click="checkAllineamentoRose(true)">
          Check allineamento squadre
        </v-btn>
      </div>

          <div > L'amministratore d'asta:</div>
          <ul>
            <li>E' l'unica persona che può cambiare le impostazioni, far partire o fermare l'asta etc...</li>
            <li><b class="error--text">Deve rimanere SEMPRE ONLINE (pallino verde) o Asta
            Live si bloccherà</b>
         </li>
          </ul>

          <div class="mt-2"><v-icon small class="cyan--text">info</v-icon> Utile se l'{{ adminLegaDivisioneLabel }} vuole delegare la gestione di Asta Live a un altro partecipante dell'asta</div>

          <div class="mt-2" ><v-icon small class="cyan--text">info</v-icon> Puó essere utile cambiare l'amministratore d'asta durante il corso dell'asta se quello attuale ha completato la rosa e decide di abbandonare Asta Live. Diventerebbe quindi col pallino rosso e Asta Live, per quanto scritto sopra, si bloccherebbe. In tal caso basta appunto cambiare l'amministratore d'asta per far proseguire l'asta normalmente

          </div>

          </v-alert>

          <v-alert
                    dense
        text
        color="warning darken-2"
class="mt-4"
        v-if="!Config.STANDALONE">
            <b>Chi ha il permesso di impostare/cambiare l'amministratore d'asta?</b>
              <v-select
                :key="adminPermissionSelectKey"
                :value="adminPermission"
                :items="adminPermissionOptions"
                item-text="text"
                item-value="value"
                :menu-props="{ offsetY: true, contentClass: 'admin-permission-menu' }"
                dense
                outlined
                hide-details
                class="mt-2 mb-2 admin-select-warning"
                @change="saveAdminPermission"
              >
                <template v-slot:selection="{ item }">
                  <span>{{ item.text }}</span>
                </template>
                <template v-slot:item="{ item }">
                  <v-list-item-content class="admin-permission-option">
                    <v-list-item-title class="admin-permission-option-title font-weight-bold">
                      {{ item.text }}
                    </v-list-item-title>
                    <v-list-item-subtitle class="admin-permission-option-description">
                      {{ item.description }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </template>
              </v-select>
              <div class="caption">
                 <v-icon small class="warning--text text--darken-2">info</v-icon> A prescindere dalla scelta, l'{{ adminLegaDivisioneLabel }} potrá sempre cambiare l'amministratore d'asta.
              </div>
              <div class="admin-leghe-info mt-3">
                <div class="admin-leghe-info-row" v-if="adminLegaUid">
                  <v-avatar size="28" class="mr-2">
                    <img v-if="adminLegaInfo.pic" :src="adminLegaInfo.pic" />
                    <v-icon v-else small>person</v-icon>
                  </v-avatar>
                  <div>
                    <div class="admin-leghe-info-label">Amministratore di lega</div>
                    <div class="admin-leghe-info-name">{{ adminLegaInfo.name || adminLegaUid }}</div>
                  </div>
                </div>
                <div class="admin-leghe-info-row mt-2" v-if="hasDivisioni">
                  <v-avatar size="28" class="mr-2">
                    <img v-if="adminDivisioneInfo.pic" :src="adminDivisioneInfo.pic" />
                    <v-icon v-else small>person</v-icon>
                  </v-avatar>
                  <div>
                    <div class="admin-leghe-info-label">Amministratore di divisione</div>
                    <div class="admin-leghe-info-name">{{ adminDivisioneInfo.name || adminDivisioneUid || "Non ancora impostato" }}</div>
                  </div>
                </div>
              </div>
          </v-alert>
      </div>
    </v-sheet>
  </v-dialog>
</template>

<script>
import db from "../../js/db";
import * as api from "../../js/api";
import Constants from "../../js/constants";
import mixins from "../../js/mixins";
import toast from "../../js/toast";
import Vuex from "vuex";

export default {
  name: "asta-change-admin",
  mixins: [mixins, toast],
  components: {},
  data() {
    return {
      dialog: false,
      selectedAdminUid: null,
      adminSelectVersion: 0,
      adminPermissionSelectVersion: 0,
      adminUsersInfo: {},
    };
  },

  mounted() {
    console.log("--> AstaChangeAdmin ready.");
    db.on("promptChangeAdmin", this.show);
  },

  destroyed() {
    console.log("<-- AstaChangeAdmin destroyed.");
    db.off("promptChangeAdmin", this.show);
  },

  watch: {
    adminUid() {
      if (this.dialog) {
        this.resetSelectedAdmin();
      }
    },
    adminLegaUid() {
      this.loadAdminLegaDivisioneInfo();
    },
    adminDivisioneUid() {
      this.loadAdminLegaDivisioneInfo();
    },
  },

  methods: {
    show() {
      this.resetSelectedAdmin();
      this.dialog = true;
      this.loadAdminLegaDivisioneInfo();
    },
    dismiss() {
      this.dialog = false;
    },
    squadraDisabled(squadra_id) {
      return this.adminUid == squadra_id;
    },
    squadraPresenceClass(squadra_id) {
      const presence = this.asta_online[squadra_id];
      return this.getPresenceClass(presence);
    },
    resetSelectedAdmin() {
      this.selectedAdminUid = this.isAdminSet ? this.adminUid : null;
      this.adminSelectVersion += 1;
    },
    resetAdminPermissionSelect() {
      this.adminPermissionSelectVersion += 1;
    },
    firebaseUidToFpUid(uid) {
      return uid ? this.fp_uid(uid) : "";
    },
    normalizeAdminUserInfo(user, uid) {
      const name = user ? user.name || user.nome || user.username : "";
      const pic = user ? user.pictureUrlExt || user.pic || user.picture || user.avatar : "";

      return {
        name: name || uid,
        pic: pic || "",
      };
    },
    loadAdminUserInfo(uid) {
      if (!uid || this.adminUsersInfo[uid] || this.Config.STANDALONE) {
        return;
      }

      const fpUid = this.firebaseUidToFpUid(uid);
      if (!fpUid) {
        return;
      }

      api
        .getUserPublicInfo(fpUid)
        .then((user) => {
          this.$set(this.adminUsersInfo, uid, this.normalizeAdminUserInfo(user, uid));
        })
        .catch((err) => {
          console.error("Admin user info non disponibile", uid, err);
        });
    },
    loadAdminLegaDivisioneInfo() {
      if (this.Config.STANDALONE) {
        return;
      }

      this.loadAdminUserInfo(this.adminLegaUid);
      if (this.hasDivisioni) {
        this.loadAdminUserInfo(this.adminDivisioneUid);
      }
    },
    showAdminPermissionDeniedAlert() {
      Swal.fire({
        icon: "error",
        title: "Attenzione",
        text: "Questa opzione può essere modificata solo dall'" + this.adminLegaDivisioneLabel + ".",
        confirmButtonText: "Ok, ho capito",
      });
    },
    showChangeAdminDeniedAlert() {
      Swal.fire({
        icon: "error",
        title: "Attenzione",
        text: "Non hai i permessi per modificare l'amministratore d'asta.",
        confirmButtonText: "Ok, ho capito",
      });
    },
    change(uid) {
      if (!this.canChangeAdminAsta) {
        if (!this.isAdminSet && !this.my_squadra) {
          Swal.fire({
            icon: "error",
            title: "Attenzione",
            text: "L'amministratore è impostabile solo da una delle squadre partecipanti all'asta",
            confirmButtonText: "Ok, ho capito",
          });
          this.resetSelectedAdmin();
          return;
        }

        this.showChangeAdminDeniedAlert();
        this.resetSelectedAdmin();
        return;
      }

      Swal.fire({
        title: "Confermi? ",
        text: this.adminChangeConfirmText,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Si",
        cancelButtonText: "No",
      }).then((result) => {
        if (result.isConfirmed == true) {
          const saveAdmin = this.canManageAdminPermission
            ? db.updateAdminAndPermission(uid, this.adminPermission)
            : db.updateAdmin(uid);

          saveAdmin
            .then(() => {
              this.successToast("Amministratore modificato", "");
            })
            .catch(() => {
              this.resetSelectedAdmin();
              this.errorToast("Amministratore non modificato", "");
            });
        } else {
          this.resetSelectedAdmin();
        }
      });
    },
    saveAdminPermission(adminPermission) {
      if (adminPermission == this.adminPermission) {
        return;
      }

      if (!this.canManageAdminPermission) {
        this.showAdminPermissionDeniedAlert();
        this.resetAdminPermissionSelect();
        return;
      }

      if (adminPermission == Constants.ADMIN_PERMISSION.ADMIN_ASTA && !this.isAdminSet) {
        Swal.fire({
          icon: "error",
          title: "Attenzione",
          text: "Prima devi scegliere un amministratore d'asta.",
          confirmButtonText: "Ok, ho capito",
        });
        this.resetAdminPermissionSelect();
        return;
      }

      db.updateAdminPermission(adminPermission)
        .then(() => {
          this.successToast("Opzione salvata", "");
        })
        .catch(() => {
          this.resetAdminPermissionSelect();
          this.errorToast("Opzione non salvata", "");
        });
    },
  },
  computed: {
    ...Vuex.mapGetters(["asta_squadre_array"]),
    adminPermissionOptions() {
      return [
        {
          text: "Chiunque partecipi all'asta",
          value: Constants.ADMIN_PERMISSION.ANYONE,
          description: "Ogni squadra partecipante può impostare o cambiare l'amministratore d'asta.",
        },
        {
          text: "Solo l'amministratore d'asta",
          value: Constants.ADMIN_PERMISSION.ADMIN_ASTA,
          description: "L'amministratore d'asta attuale può passare il ruolo a un'altra squadra.",
        },
        {
          text: "Solo " + this.adminLegaDivisioneLabel,
          value: Constants.ADMIN_PERMISSION.ADMIN_LEGA_DIVISIONE,
          description: "Solo l'" + this.adminLegaDivisioneLabel + " può scegliere l'amministratore d'asta.",
        },
      ];
    },
    adminSquadreOptions() {
      return this.asta_squadre_array.map((sq) => {
        return {
          id: sq.id,
          name: sq.name,
          pic: this.squadra(sq.id).pic,
          presenceClass: this.squadraPresenceClass(sq.id),
          disabled: this.squadraDisabled(sq.id),
        };
      });
    },
    canManageAdminPermission() {
      return this.permissionAdminLegaDivisione;
    },
    adminLegaInfo() {
      return this.adminUsersInfo[this.adminLegaUid] || {};
    },
    adminDivisioneInfo() {
      return this.adminUsersInfo[this.adminDivisioneUid] || {};
    },
    adminSelectKey() {
      return (this.isAdminSet ? this.adminUid : "no_admin") + "_" + this.adminSelectVersion;
    },
    adminPermissionSelectKey() {
      return this.adminPermission + "_" + this.adminPermissionSelectVersion;
    },
    adminChangeConfirmText() {
      if (this.Config.STANDALONE) {
        return "Ricorda che solo l'amministratore d'asta che hai selezionato potrà poi riassegnare tale ruolo a qualcun altro.";
      }

      if (this.adminPermission == Constants.ADMIN_PERMISSION.ANYONE) {
        return "Attualmente l'" + this.adminLegaDivisioneLabel + " ha impostato che qualunque partecipante all'asta potrà ricambiare l'amministratore d'asta.";
      }

      if (this.adminPermission == Constants.ADMIN_PERMISSION.ADMIN_LEGA_DIVISIONE) {
        return "Attualmente l'" + this.adminLegaDivisioneLabel + " ha impostato che solo l'" + this.adminLegaDivisioneLabel + " potrà ricambiare l'amministratore d'asta.";
      }

      return "Attualmente l'" + this.adminLegaDivisioneLabel + " ha impostato che solo la persona appena scelta potrà ricambiare l'amministratore d'asta.";
    },
  },
};
</script>
<style lang="scss" scoped>
.admin-permission-option-title,
.admin-permission-option-description {
  white-space: normal;
  overflow: visible;
  text-overflow: unset;
  line-height: 1.35;
}

.admin-permission-option-description {
  display: block;
}

.admin-squadra-option {
  display: flex;
  align-items: center;
  min-width: 0;
}

.admin-squadra-name {
  min-width: 0;
  white-space: normal;
  overflow: visible;
  text-overflow: unset;
  line-height: 1.3;
}

.admin-leghe-info-row {
  display: flex;
  align-items: center;
  min-width: 0;
}

.admin-leghe-info-label {
  font-size: 11px;
  font-weight: 700;
  line-height: 1.2;
  text-transform: uppercase;
}

.admin-leghe-info-name {
  line-height: 1.2;
  word-break: break-word;
}
</style>
<style lang="scss">
.admin-select-cyan.v-text-field--outlined fieldset {
  border-color: #0097a7 !important;
}

.admin-select-warning.v-text-field--outlined fieldset {
  border-color: #a55c13 !important;
}

.admin-permission-menu {
  max-width: 92vw;
}

.admin-permission-menu .v-list-item {
  min-height: auto;
}

.admin-permission-menu .admin-permission-option {
  min-width: 0;
  padding-top: 10px;
  padding-bottom: 10px;
}

.admin-permission-menu .admin-permission-option-title,
.admin-permission-menu .admin-permission-option-description {
  white-space: normal;
  overflow: visible;
  text-overflow: unset;
  word-break: break-word;
  line-height: 1.35;
}

.admin-permission-menu .admin-permission-option-description {
  display: block;
}

.admin-squadre-menu {
  max-width: 92vw;
}

.admin-squadre-menu .v-list-item__title {
  white-space: normal;
  overflow: visible;
  text-overflow: unset;
  line-height: 1.3;
}

.admin-squadre-menu .admin-squadra-name {
  white-space: normal;
  overflow: visible;
  text-overflow: unset;
  word-break: break-word;
}
</style>
